module.exports = __webpack_public_path__ + "ClientApp/content/organizations/CPEPracticeCAETA.png";